// extracted by mini-css-extract-plugin
export var globalWrapper = "BannerImage-module--global-wrapper--2zrxg";
export var globalHeader = "BannerImage-module--global-header--2C-Ve";
export var postListItem = "BannerImage-module--post-list-item--vP7VK";
export var bio = "BannerImage-module--bio--3H5ET";
export var bioAvatar = "BannerImage-module--bio-avatar--2Gnx-";
export var blogPost = "BannerImage-module--blog-post--E3LJA";
export var blogPostNav = "BannerImage-module--blog-post-nav--3bYVw";
export var gatsbyHighlight = "BannerImage-module--gatsby-highlight--2h71c";
export var screenReaderText = "BannerImage-module--screen-reader-text--3l5_H";
export var image = "BannerImage-module--image--3vqpS";